import React from 'react';
import { LogoGridData, LogoGridItem, PageSlice } from '@contracts';
import Logos from './Logos';

type Props = {
  slice: PageSlice;
};

const LogoGrid: React.FC<Props> = ({ slice }) => {
  const sliceDetails = slice.primary as LogoGridData;
  const sliceItems = slice.items as LogoGridItem[];
  const logoImages = sliceItems.map((item) => item.logo_image?.url ?? '');

  return (
    <Logos
      background={sliceDetails.background_text}
      title={sliceDetails.title1?.text ?? ''}
      logos={logoImages}
      highlightedLogoImage={sliceDetails.highlighted_logo_image?.url ?? ''}
      highlightedLogoText={sliceDetails.highlighted_logo_text?.text ?? ''}
    />
  );
};

export default LogoGrid;
